import { formatMessage, IS_RV, IS_BOAT } from '~/brands'

const RvFilters = {
  odometer: 'Odometer'
}

const boatFilters = {
  boatTrailerLengthInMeters: 'Boat Trailer Length, m',
  boatTrailerLengthInFeet: 'Boat Trailer Length, ft',
  boatDraft: 'Boat draft, m'
}

export const filters = {
  makeModel: 'Make & Model & Series',
  model: 'Model',
  series: 'Series',
  category: 'Category',
  subcategory: 'Subcategory',
  price: 'Price',
  year: 'Year',
  adType: 'Ad Type',
  location: 'Location',
  keyword: 'Keyword',
  lengthInMeters: 'Length in meters',
  lengthInFeets: 'Length in feets',
  towBallWeight: 'Tow Ball Weight',
  aggregateTrailerMass: 'Aggregate Trailer Mass',
  sleepsBerthCount: 'Sleeps/Berth Count',
  sellerType: 'Seller Type',
  dealer: 'Dealer',
  sellerOfferedServices: 'Seller Offered Services',
  ...(IS_RV && RvFilters),
  ...(IS_BOAT && boatFilters)
}

export const filterGroupedList = [
  {
    title: 'General',
    items: [
      filters.makeModel,
      filters.category,
      filters.price,
      filters.year,
      filters.adType,
      filters?.odometer,
      filters.location,
      filters.keyword
    ]
  },
  {
    title: formatMessage('searchPage.filters.paraments'),
    items: [
      filters.lengthInMeters,
      filters.lengthInFeets,
      filters.boatTrailerLengthInMeters,
      filters.boatTrailerLengthInFeet,
      filters.boatDraft,
      filters.towBallWeight,
      filters.aggregateTrailerMass,
      filters.sleepsBerthCount
    ]
  },
  {
    title: 'Seller details',
    items: [filters.sellerType, filters.dealer, filters.sellerOfferedServices]
  }
]
